import useSWR from "swr";
import { Team } from "../../../globals/interfaces";
import useUser from "../../../customHooks/useUser";
import { useEffect, useState } from "react";
import { membersRefreshTriggerState, selectedTeamIdState, teamsState } from "./atoms";
import { customFetcher, notify } from "../../../utils";
import apiClient from "../../../apiClient";
import _ from "lodash";

export type CreateUpdateItem = (data: Team, updateTeam: boolean) => Promise<boolean>;

export type DeleteTeam = (selectedTeamId: number | undefined) => Promise<boolean>;

export default function useTeams (runQuery: boolean, searchEmployee?: string) {
    const { user } = useUser();
    // const {
    //     data: teams,
    //     mutate
    // } = useSWR(runQuery && searchEmployee ? `/team/employee/${searchEmployee}` : `/team/unit/${user.s_unit}`, customFetcher<Team>, {
    //     fallbackData: []
    // });
    const teams = [];
    const mutate: any = () => {};
    const [selectedTeamId, setSelectedTeamId] = useState<number>(undefined);
    const selectedTeam = teams.find(team => team.id === selectedTeamId);

    useEffect(() => {
        setSelectedTeamId(undefined);
    }, [user.s_unit, searchEmployee]);

    const createUpdateTeam: CreateUpdateItem = async (data: Team, updateTeam: boolean) => {
        try {
            const res = await apiClient[updateTeam ? 'put' : 'post'](`/team`, data);
            mutate();
            return true;
        } catch (err) {
            console.log(err);
            if (String(err).includes('400')) {
                notify('Duplicate group name. Please change the name.', 'error');
            }
            return false;
        }
    }

    const deleteTeam: DeleteTeam = async (selectedTeamId: number | undefined) => {
        if (!selectedTeamId) return;

        try {
            await apiClient.delete(`/team/${selectedTeamId}`);
            const updatedData = teams.filter(item => item.id !== selectedTeamId);
            mutate(updatedData, false);
            setSelectedTeamId(undefined);
            return true;
        } catch (err) {
            alert(err);
            return false;
        }
    }

    return {
        teams,
        selectedTeamId,
        setSelectedTeamId,
        selectedTeam,
        createUpdateTeam,
        deleteTeam
    }
}